import React from 'react';

export default function DeviceStatusDot({ isOnline }) {
    const online = isOnline === true;

    return (
        <span
            className={`device-status-slot device-status-slot-${online ? 'online' : 'offline'}`}
            title={online ? 'Online' : 'Offline'}
            aria-label={online ? 'Online' : 'Offline'}
        >
            <span className="device-status-dot-wrap">
                {online && <span className="device-status-ring" aria-hidden="true" />}
                <span className={`device-status-dot device-status-dot-${online ? 'online' : 'offline'}`} />
            </span>
        </span>
    );
}
